import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { PagesComponent } from "./pages/pages.component";
import { LoginComponent } from "./login/login.component";
import { RecoveryPasswordComponent } from "./recovery-password/recovery-password.component";
import { RegistrationComponent } from "./registration/registration.component";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { UserComponent } from "./pages/user/user.component";
import { PresentationComponent } from "./presentation/presentation.component";
import { ContainerComponent } from "./pages/container.component";
import { Page404Component } from "./pages/page404/page404.component";
import { ContainerPublicComponent } from "./pages/container-public.component";
import { ModerationComponent } from "./moderation/moderation.component";
import { LiveComponent } from "./live/live.component";

let routes: Routes = [
  {
    path: "", component: ContainerPublicComponent,
    children: []
  },
  {
    path: "",
    component: PagesComponent,
    children: [{ path: "profilo", component: UserComponent },],
  },
  {
    path: "", component: ContainerComponent,
    children: []
  },
  // { path: '**', redirectTo: '/login' },
  {path:'live',component:LiveComponent},
  {path:'live/:id',component:LiveComponent},
  { path: "login", component: LoginComponent },
  { path: "registrazione", component: RegistrationComponent },
  { path: "recupero-password", component: RecoveryPasswordComponent },
  { path: "cambia-password", component: ChangePasswordComponent },
  { path: "registration", component: RegistrationComponent },
  { path: "recovery-password", component: RecoveryPasswordComponent },
  { path: "change-password", component: ChangePasswordComponent },
  { path: "presentation/:id", component: PresentationComponent },
    // { path: "confirm", component:  
  { path: "moderation/:id", component: ModerationComponent },
  { path: ":id", component: Page404Component },
  { path: ":id/:id", component: Page404Component },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
